import { css } from '@emotion/core';
import { Theme } from 'features/Theme';

const styles = {
  walletButton: (theme: Theme) => css`
    height: 48px;
    padding: 0 ${theme.mui.spacing(1)}px;
  `,
  hiddenAppleButton: () => css`
    display: none;
  `,
};

export default styles;
